import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import Chart from 'chart.js/auto';

@Component({
  selector: 'app-most-consumed-product-type-chart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './most-consumed-product-type-chart.component.html',
  styleUrl: './most-consumed-product-type-chart.component.scss'
})
export class MostConsumedProductTypeChartComponent implements AfterViewInit, OnChanges {
  @Input() isLoadingMostConsumedProductType: boolean = false;
  @Input() mostConsumedProductTypeData: any = null;
  @Input() mostConsumedProductTypeCategory: 'body_part' | 'implant' = 'implant';
  @Output() mostConsumedProductTypeCategoryChange = new EventEmitter<'body_part' | 'implant'>();
  @Output() toggle = new EventEmitter<'body_part' | 'implant'>();
  @ViewChild('chart4', { static: false }) chart4!: ElementRef<HTMLCanvasElement>;
  private chartInstance: any;

  ngAfterViewInit() {
    this.renderChart();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['mostConsumedProductTypeData'] && !changes['mostConsumedProductTypeData'].firstChange) {
      this.renderChart();
    }
  }

  renderChart() {
    if (!this.mostConsumedProductTypeData || !this.chart4) return;
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
    const labels = this.mostConsumedProductTypeData.product_types?.map((p: any) => p.product_type_name) || [];
    const data = this.mostConsumedProductTypeData.product_types?.map((p: any) => p.count) || [];
    const colors = [
      '#4E79A7', // blue
      '#F28E2B', // orange
      '#E15759', // red
      '#76B7B2', // teal
      '#59A14F', // green
      '#EDC948', // yellow
      '#B07AA1', // purple
      '#FF9DA7', // pink
      '#9C755F', // brown
      '#BAB0AC'  // gray
    ];
    this.chartInstance = new Chart(this.chart4.nativeElement, {
      type: 'doughnut',
      data: {
        labels: labels,
        datasets: [{
          label: this.mostConsumedProductTypeCategory === 'body_part' ? 'Body Part' : 'Implant',
          data: data,
          backgroundColor: colors.slice(0, data.length),
        }]
      },
      options: {
        responsive: true,
        plugins: {
          legend: { display: true, position: 'bottom' }
        }
      }
    });
  }

  onToggle(type: 'body_part' | 'implant') {
    this.mostConsumedProductTypeCategoryChange.emit(type);
    this.toggle.emit(type);
  }
}
